import { Typography } from '@sunwebgroup/uds-ui/typography'
import { cn } from '@sunwebgroup/uds-ui/utils'
import * as React from 'react'
import styles from './Filters.module.css'

export function FilterContainer({ children }: React.PropsWithChildren) {
  return <div className={styles.filterContainer}>{children}</div>
}

export function FilterItemsContainer({ children }: React.PropsWithChildren) {
  return <div className={styles.filterItemsContainer}>{children}</div>
}

export function FilterLabel({ children }: React.PropsWithChildren) {
  return <Typography className={styles.filterLabel}>{children}</Typography>
}

export function FilterDescription({ children }: React.PropsWithChildren) {
  return <Typography className={styles.filterDescription}>{children}</Typography>
}

export function FilterOptionValue({ children }: React.PropsWithChildren) {
  return <Typography className={styles.filterOptionValue}>{children}</Typography>
}

export function FilterOptionHelpText({ children }: React.PropsWithChildren) {
  return <Typography className={styles.filterOptionHelpText}>{children}</Typography>
}

export function FilterOptionPrice({ children }: React.PropsWithChildren) {
  return <Typography className={styles.filterOptionPrice}>{children}</Typography>
}

export function FilterItemOptionWrapper({ children, ...props }: React.LabelHTMLAttributes<HTMLLabelElement>) {
  return (
    <label {...props} className={cn(styles.filterItemOptionWrapper, props.className)}>
      {children}
    </label>
  )
}

export function FilterItemOption({ children }: React.PropsWithChildren) {
  return <div className={styles.filterItemOption}>{children}</div>
}

export function FilterItemOptionContent({ children }: React.PropsWithChildren) {
  return <div className={styles.filterItemOptionContent}>{children}</div>
}

export function FilterItemOptionControl({ children }: React.PropsWithChildren) {
  return <div className={styles.filterItemOptionControl}>{children}</div>
}

export function FilterItemOptionTrailing({ children }: React.PropsWithChildren) {
  return <div className={styles.filterItemOptionTrailing}>{children}</div>
}
